import { useHistory } from "react-router";
import axios from "axios";

import { getCompImgUrl, displayFlagByCountryCode, getValueByKey } from "../../Utils/utils";
import React, { useState, useEffect } from "react";

import "./Composers.css";

function Composers(props, userData) {
  const { composers } = props;
  const [artisttype, setArtisttype] = useState([]);
  const userLang = userData?.language || 'de';
  const history = useHistory();
  
  useEffect(() => {
	let isMounted = true; 
    const lang = userData?.language || "de";
    axios.get(`/settings/options?type=artisttype&lang=${lang}`)
      .then(res => { if (res.data && isMounted) setArtisttype(res.data); })
      .catch(err => console.error("Fehler beim Laden der Kategorien:", err));
	return () => { isMounted = false; };
  }, [userData]);  

  const composerItems = composers.map((composer) => {
    const imgUrl = getCompImgUrl(composer.portraitUrl);

    return (
      <li
        key={composer.name}
        onClick={() => history.push(`/composer/${composer.safe_name}`)}
      >
        <div className="box-container-comp remove_shadow">
          <img className="thumbnail-image-comp" src={imgUrl} alt="Portrait" />
          <div className="comp-name-container">
            <span className="comp-name">{composer.name}</span>
          </div>
			<div className="life-container">
			  <span className="life-text">{composer.disambiguation}<br/>
			  <span className="text-highlight">{getValueByKey(artisttype, composer.type, userLang, "artisttype")} <br/></span>
			  {displayFlagByCountryCode(composer.countryCode)} {composer.countryCode}<br/><br/></span>
			</div>
        </div>
      </li>
    );
  });

  return <ul className="all-comp-container">{composerItems}</ul>;
}

export default Composers;
